import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b5f02aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "generalContainer" }
const _hoisted_2 = { class: "taskContainer" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "taskContainer__name" }
const _hoisted_5 = { class: "taskContainer__date" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " add_circle ", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "newTask" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " add_circle ", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " cancel ", -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCharging = _resolveComponent("ModalCharging")!
  const _component_TaskModal = _resolveComponent("TaskModal")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ModalCharging, { open: _ctx.isLoading }, null, 8, ["open"]),
    _createVNode(_component_ModalComponent, {
      open: _ctx.openModal,
      onCloseModal: _ctx.closeTaskModal
    }, {
      default: _withCtx(() => [
        (_ctx.loadModal)
          ? (_openBlock(), _createBlock(_component_TaskModal, {
              key: 0,
              task: _ctx.task,
              "users-on-project": _ctx.usersOnProject,
              onTaskUpdated: _ctx.emitTaskUpdated,
              onDeletedTask: _ctx.emitTaskDeleted
            }, null, 8, ["task", "users-on-project", "onTaskUpdated", "onDeletedTask"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open", "onCloseModal"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "taskContainer__circle",
        src: _ctx.checkedTask,
        alt: "see more",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleCompleted && _ctx.toggleCompleted(...args)))
      }, null, 8, _hoisted_3),
      _createElementVNode("span", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openTask && _ctx.openTask(...args))),
        class: _normalizeClass({
          'span--grey': _ctx.task.state === '0',
          'span--green': _ctx.task.state === '1',
          'span--yellow': _ctx.task.state === '0.5'
        })
      }, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.task.name), 1),
        _createElementVNode("p", _hoisted_5, " Date: " + _toDisplayString(!!_ctx.task.deliverDate && _ctx.task.deliverDate !== ''
            ? _ctx.task.deliverDate : 'No establecida'), 1),
        (!_ctx.isSubTask)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addSubTask && _ctx.addSubTask(...args)), ["stop"])),
              class: "addButton"
            }, _hoisted_7))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_8, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Nombre de la tarea",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newTask.name) = $event))
      }, null, 512), [
        [_vModelText, _ctx.newTask.name]
      ]),
      _createElementVNode("button", {
        class: "newTask__button--add",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createNewSubTask && _ctx.createNewSubTask(...args)))
      }, _hoisted_10),
      _createElementVNode("button", {
        class: "newTask__button--cancel",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelAddTask && _ctx.cancelAddTask(...args)))
      }, _hoisted_12)
    ], 512), [
      [_vShow, _ctx.showOnHover]
    ])
  ]))
}